import React from "react";
import styles from "./StudentLife.module.css";
import Image from "next/image";

interface TitleDescription {
  id: number;
  title: string;
  description: string;
}

interface ImageData {
  id: number;
  documentId: string;
  url: string;
  alternativeText: string;
}

interface Card {
  id: number;
  title_description: TitleDescription;
  images: ImageData[];
}

interface StudentLifeData {
  title_description: TitleDescription;
  cards: Card[];
}

interface StudentLifeProps {
  data?: StudentLifeData;
}

const StudentLife: React.FC<StudentLifeProps> = ({ data }) => {
  const { title_description, cards } = data || {};

  return (
    <div className="container" style={{ minHeight: "450px" }}>
      <section className={styles.StudentContainer}>
        <h2 className={styles.title}>{title_description?.title}</h2>
        <p className={styles.subtitle}>{title_description?.description}</p>

        <div className={styles.grid}>
          {cards?.map((card, index) => (
            <div key={card?.id} className={styles.card}>
              {card?.images?.length > 0 ? (
                <Image
                  src={card?.images[0].url}
                  alt={card?.images[0]?.alternativeText || "sudentlifeImages"}
                  title={card?.images[0]?.alternativeText || "sudentlifeImages"}
                  width={400}
                  height={200}
                  className={styles.cardImage}
                  style={{
                    width: 400,
                    height: 200,
                  }}
                  priority={index === 0 ? true : false}
                  loading={index === 0 ? "eager" : "lazy"}
                />
              ) : (
                <div className={styles.placeholderImage}>
                  Image not available
                </div>
              )}
              <div className={styles.cardContent}>
                <h3 className={styles.cardTitle}>
                  {card?.title_description?.title}
                </h3>
                <p className={styles.cardDescription}>
                  {card?.title_description?.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default StudentLife;
